// ===========================================================================
// SocialSummary — resumen del perfil social en la ficha: las 7 dimensiones como
// fila de indicadores de color + categoría global + acceso al editor.
// (El perfil viene del page; los endpoints sociales son contrato propuesto.)
// ===========================================================================
import React from "react";
import { Box, Paper, Typography, Stack, Button, Chip, Tooltip } from "@mui/material";
import RuleIcon from "@mui/icons-material/Rule";
import { SDOH_LEVELS, SOCIAL_CATEGORY_COLORS } from "../../common/constants";

const levelMeta = (value) => SDOH_LEVELS.find((l) => l.value === value) || SDOH_LEVELS[0];

export default function SocialSummary({ profile, onReview }) {
  const dimensions = profile?.dimensions || [];
  const socColor = SOCIAL_CATEGORY_COLORS[profile?.globalCategory] || "#9e9e9e";

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, mb: 2.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Social profile
        </Typography>
        <Chip label="Decision support" size="small" variant="outlined" sx={{ height: 18, fontSize: "0.6rem" }} />
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Global category:
        </Typography>
        <Chip label={profile?.globalCategory || "Unclassified"} size="small" sx={{ color: "#fff", bgcolor: socColor, fontWeight: 600 }} />
        {profile?.globalSource === "auto_suggested" && (
          <Chip label="System suggested" size="small" color="warning" variant="outlined" />
        )}
        {profile?.globalSource === "confirmed" && (
          <Chip label="Clinician confirmed" size="small" color="success" variant="outlined" />
        )}
      </Stack>

      <Stack direction="row" spacing={1.5} useFlexGap flexWrap="wrap" sx={{ mb: 2 }}>
        {dimensions.map((d) => {
          const meta = levelMeta(d.level);
          return (
            <Tooltip key={d.key} title={`${d.label} · ${meta.label}${d.suggestionBasis ? ` — ${d.suggestionBasis}` : ""}`} arrow>
              <Box sx={{ textAlign: "center", minWidth: 78 }}>
                <Box sx={{ height: 8, borderRadius: 4, bgcolor: meta.color, mb: 0.5 }} />
                <Typography variant="caption" sx={{ display: "block", lineHeight: 1.1 }}>
                  {d.label.split(" ")[0]}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                  {meta.label}
                </Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Stack>

      <Button variant="outlined" startIcon={<RuleIcon />} onClick={onReview} sx={{ textTransform: "none" }}>
        Review stratification
      </Button>
    </Paper>
  );
}
